import { Core, Decorative } from "@faire/design-tokens";
import { Spacer } from "@faire/web/slate/spacing";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

import {
  Section,
  SectionHeadline,
} from "@faire/retailer/views/careers/__internal__/common/common";
import { ViewOpeningsButton } from "@faire/retailer/views/careers/ViewOpeningsButton";

export const JobOpeningsSection: React.FC = () => {
  return (
    <Section
      $withHorizontalPadding
      $withVerticalPadding
      $backgroundColor={Decorative.shade.yellow}
      align="center"
    >
      <SectionHeadline color={Core.text.inverse} align="center">
        <StrictLocalMsg
          defaultMessage="Join us and help create a bright future for independent retailers & brands"
          description={{
            text: "Section title convincing people to apply for jobs at Faire",
            img: "https://cdn.faire.com/fastly/577f6ad2e2ca8e22a0f239dbe635bdd3f9a261e70e60d8bf3118a9366dbfae4f.png",
          }}
        />
      </SectionHeadline>
      <Spacer height={{ desktopAndAbove: "5x", mobileAndAbove: "4x" }} />
      <ViewOpeningsButton
        isSecondary
        buttonText={
          <StrictLocalMsg
            defaultMessage="All Job Openings"
            description={{
              text: "Button text to navigate to a job openings page",
              img: "https://cdn.faire.com/fastly/577f6ad2e2ca8e22a0f239dbe635bdd3f9a261e70e60d8bf3118a9366dbfae4f.png",
            }}
          />
        }
      />
    </Section>
  );
};
